import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell as MuiTableCell,
  TableBody,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
}));

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: '0.85rem',
  lineHeight: '0.9rem',
}));

function PriceTable({ prices, t }) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('apModal.dates')}</TableCell>
            <TableCell>{t('apModal.ms')} </TableCell>
            <TableCell>{t('apModal.rate')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {prices.map((priceInfo, index) => (
            <StyledTableRow key={priceInfo.dates}>
              <TableCell>{priceInfo.dates}</TableCell>
              <TableCell>{priceInfo.minStay}</TableCell>
              <TableCell>€{priceInfo.rate}</TableCell>
            </StyledTableRow>
          ))}
          <StyledTableRow>
            <TableCell colSpan={2}>{t('apModal.transfer')}</TableCell>
            <TableCell>€60</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
      <Typography
        variant="caption"
        sx={{ display: 'block', mt: 1.5, color: 'text.secondary' }}
      >
        {t('apModal.priceDisclaimer')}
      </Typography>
    </TableContainer>
  );
}

export default PriceTable;
